import { MapperBase } from '../../utilities/mapper-base';
import { CaseNote } from '../ui/case-note.model';
import { DocNoteResource } from '../resource/doc-note.resource';

export class CaseNoteToDocNoteResourceMapper extends MapperBase<CaseNote, DocNoteResource> {
    map(source: CaseNote): DocNoteResource {
        const dest = {} as DocNoteResource;
        dest.docNoteId = source.id;
        dest.docId = source.documentId;
        dest.docNoteTitle = source.title;
        dest.docNote = source.body;
		dest.author = source.author;
		dest.dateTimeCreated = source.createdAt;
		dest.documentName = source.documentName;
		dest.isPrivate = source.isPrivate;
		dest.pageNumber = source.pageNumber;
		dest.pageCount = source.pageCount;
		return dest;
    }

}
